import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Header, Titulo, ContenedorHeader } from "./../elementos/Header";
import Boton from "./../elementos/Boton";
import {
  Formulario,
  Input,
  ContenedorBoton
} from "./../elementos/ElementosDeFormulario";
import { ReactComponent as SvgLogin } from "./../imagenes/login.svg";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { auth } from "./../firebase/firebaseConfig";
import Alerta from "./../elementos/Alerta";

const Svg = styled(SvgLogin)`
  width: 100%;
  max-height: 12.5rem; /*200px */
  margin-bottom: 1.25rem; /* 20px */
`;

const InicioSesion = () => {
  const history = useHistory();
  const [correo, establecerCorreo] = useState("");
  const [password, establecerPassword] = useState("");
  //estados de alertas de formulario
  const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
  const [alerta, cambiarAlerta] = useState({});

  const handleChange = e => {
    if (e.target.name === "email") {
      establecerCorreo(e.target.value);
    } else if (e.target.name === "password") {
      establecerPassword(e.target.value);
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    //console.log(correo, password, password2);
    cambiarEstadoAlerta(false);
    cambiarAlerta({});
    //comprobamos del lado del cliente que el correo sea valido.
    const expresionRegular = /[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+/;
    //console.log(expresionRegular.test(correo));
    if (!expresionRegular.test(correo)) {
      //console.log("Ingresa un correo valido");
      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: "error",
        mensaje: "Ingrese un correo electrónico correcto"
      });
      return;
    }
    if (correo === "" || password === "") {
      //console.log("Por favor rellena todos los datos");
      cambiarEstadoAlerta(true);
      cambiarAlerta({
        tipo: "error",
        mensaje: "Por favor rellena todos los datos"
      });
      return;
    }

    try {
      await auth.signInWithEmailAndPassword(correo, password);
      //console.log("Usuario registrado con éxito");
      history.push("/");
    } catch (error) {
      cambiarEstadoAlerta(true);
      //console.log(error);
      let mensaje;
      switch (error.code) {
        case "auth/wrong-password":
          mensaje = "La contraseña no es correcta";
          break;
        case "auth/user-not-found":
          mensaje = "El usuario no ha sido encontrado";
          break;
        default:
          mensaje = "Hubo un error al intentar crear la cuenta.";
          break;
      }
      //console.log(mensaje);
      cambiarAlerta({
        tipo: "error",
        mensaje: mensaje
      });
    }
  };

  return (
    <>
      <Helmet>
        <title>Inicio de Sesión</title>
      </Helmet>

      <Header>
        <ContenedorHeader>
          <Titulo>Iniciar Sesión</Titulo>
          <div>
            <Boton to="/crear-cuenta">Registrarse</Boton>
          </div>
        </ContenedorHeader>
      </Header>

      <Formulario onSubmit={handleSubmit}>
        <Svg />
        <Input
          type="email"
          name="email"
          placeholder="Correo Electrónico"
          value={correo}
          onChange={handleChange}
        />
        <Input
          type="password"
          name="password"
          placeholder="Contraseña"
          value={password}
          onChange={handleChange}
        />

        <ContenedorBoton>
          <Boton as="button" primario type="submit">
            Iniciar Sesión
          </Boton>
        </ContenedorBoton>
      </Formulario>

      <Alerta 
         tipo={alerta.tipo}
         mensaje={alerta.mensaje}
         estadoAlerta={estadoAlerta}
         cambiarEstadoAlerta={cambiarEstadoAlerta}
      />
    </>
  );
};

export default InicioSesion;
